const FAQ_TYPES = {
  HOST: "Host",
  GENERAL: "Guest",
};

const FAQS = ["HOST", "GUEST"];

const SORT_BY = {
  PRICE_HIGH_TO_LOW: "Price high to low",
  PRICE_LOW_TO_HIGH: "Price low to high",
  NEWEST_DATE_FIRST: "Newest date first",
  OLDEST_DATE_FIRST: "Oldest date first",
};

const REPORT_TYPES = [
  {
    value: "Inappropriate Image",
    label: "Inappropriate Image",
  },
  {
    value: "Derogatory language",
    label: "Derogatory language",
  },
  {
    value: "General Incompatibility",
    label: "General Incompatibility",
  },
  {
    value: "Other",
    label: "Other",
  },
];

const GENDER = {
  MEN: "Man",
  WOMEN: "Woman",
  NON_BINARY: "Non-Binary",
};

const GENDERDECODE: Record<string, string> = {
  Men: "Man",
  Women: "Woman",
};

const CONNECTION_PREFERENCE = {
  OPEN_TO_ANYTHING: "Open to anything",
  FRIENDSHIP: "Friendship",
  DATING: "Dating",
};

const DATE_FILTER = {
  TODAY: "Today",
  TOMORROW: "Tomorrow",
  THIS_WEEKEND: "This Weekend",
};

const REVENUE_DATE_FILTER = {
  TODAY: "Today",
  THIS_WEEK: "This Week",
  THIS_MONTH: "This Month",
  ALL: "All",
};

const REVENUE_DATE_FILTER_OPTIONS = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Today",
    value: "today",
  },
  {
    label: "Last 7 Days",
    value: "last_seven_days",
  },
  {
    label: "Last 30 Days",
    value: "last_thirty_days",
  },
];

const CONNECTION_STATUS = {
  DATING: "Heart",
  OPEN_TO_ANYTHING: "Open",
  FRIENDSHIP: "Handshake",
  UNMATCH: " ",
};

const MY_EVENTS_TYPES = {
  UPCOMING: "Upcoming",
  INVITED: "Invited",
  ATTENDED: "Attended",
  // ALL_PAST: 'All Past'
};

const HOST_CENTER_TYPES = {
  UPCOMING: "Upcoming",
  PAST: "Past",
  DRAFT: "Drafts",
};

const EVENT_ATTENDING_ANSWER = {
  YES: "Yes",
  MAYBE: "Maybe",
  NO: "No",
};
const EVENT_ATTENDING_STATUS = {
  GOING: "Going",
  MAYBE: "Maybe",
  NOT_GOING: "Not Going",
};

const DRAWERS = {
  GUEST_LIST: "Guest List",
  GROUP_CHAT: "Event Chat",
  BUY_TICKETS: "Buy Tickets",
  PAYMENT: "Payment",
  TICKET: "Ticket",
  USER_TICKETS: "Tickets",
  CONNECTION: "Profile",
  TICKETS: "Tickets",
  PAYOUT_REQUEST: "Payout Request",
  PAYOUT_SUMMARY: "Payouts",
  GUEST_ATTENDANCE_LIST: "Guest Attendance",
  CONTACT_HOST: "Contact Host",
  SUBSCRIBED_LIST: "Host Subscriptions",
};

const GUEST_LIST_TABS = {
  // INVITED: "Invited",
  GOING: "Going",
  MAYBE: "Maybe",
};

const LOCAL_STORAGE = {
  USER_TOKEN: "user_token",
  USER_MOBILE_NUMBER: "userMobileNumber",
  USER_ID: "userID",
  SHOW_DETAIL_PAGE: "showDetailPage",
  CONTACT_LIST: "contactList",
  USER_EMAIL: "userEmail",
  REMEMBER_PREFERENCE: "rememberPreference",
  REQUEST_TYPE: "requestType",
  PROFILE_STATUS: "profileStatus",
  AUTH: "pinyada_admin_auth",
};

const EVENT_SHARE_TYPE = {
  SHARE: "Share",
  REDEEM: "Redeem",
};

const API_VERSION = {
  V1: "v1",
  V2: "v2",
};

enum ButtonVisibility {
  Hidden = "hidden",
  Visible = "visible",
}
const NOTIFICATION_REDIR_LIST = ["event", "like", "matched"];
const WEB_URL: any = process.env.REACT_APP_WEB_URL;
const WEB_SUPPORT_EMAIL: any = process.env.REACT_APP_WEB_SUPPORT_EMAIL;

const AUTH_NAVIGATE_OPTIONS = {
  KYC: "KYC",
  PROMPTS: "Prompts",
  NEW_USER: "NewUser",
  NEW_WEB_USER: "newWebUser",
  COMPLETED: "Completed",
  ONBOARDING: "Onboarding",
  KYC_REQUESTED: "KYC Requested",
};

const CONNECTION_REQUEST_STATUS = {
  REQUEST_SENT: "Connection Request Sent",
  REQUEST_MATCHED: "Matched",
};

const EVENT_LIST_LIMIT_PER_SCREEN = {
  DISCOVER: 20,
  EVENTS: 20,
  HOST_CENTER: 20,
  TEXT_BLAST_HOST_EVENT: 20,
  PAYOUT_PAGE_LIMIT: 20,
};

export const API_KEY_MAP: Record<string, string> = {
  "/users/get-users": process.env.REACT_APP_ADMIN_API_USER_KEY || "",
  "/users/block-user": process.env.REACT_APP_ADMIN_API_BLOCK_USER_KEY || "",
  "/users/unblock-user":
    process.env.REACT_APP_ADMIN_API_UN_BLOCK_USER_KEY || "",
  "/event/payout/get-requested-payouts":
    process.env.REACT_APP_ADMIN_API_EVENT_PAYOUT_KEY || "",
  "/event/payout/get-approved-payouts":
    process.env.REACT_APP_ADMIN_API_EVENT_PAYOUT_KEY || "",
  "/event/payout/approve-payout":
    process.env.REACT_APP_ADMIN_API_EVENT_PAYOUT_KEY || "",
  "/event/payout/approve-custom-payout":
    process.env.REACT_APP_ADMIN_API_EVENT_PAYOUT_KEY || "",
  "/events": process.env.REACT_APP_ADMIN_API_EVENT_KEY || "",
  "/fees/get-fee-details": process.env.REACT_APP_ADMIN_API_FEE_CONFIG_KEY || "",
  "/fees/get-fee-details-by-use":
    process.env.REACT_APP_ADMIN_API_FEE_CONFIG_KEY || "",
  "/fees/update-custom-fee":
    process.env.REACT_APP_ADMIN_API_FEE_CONFIG_KEY || "",
  "/event/users/get-event-guest-list":
    process.env.REACT_APP_ADMIN_API_GUEST_USERS_KEY || "",
  "/event/ticket/get-event-ticket-details":
    process.env.REACT_APP_ADMIN_API_TICKETS_KEY || "",
  "/event/ticket/get-event-scanned-tickets":
    process.env.REACT_APP_ADMIN_API_SCANNED_TICKETS_KEY || "",
  "/event/get-promo-codes":
    process.env.REACT_APP_ADMIN_API_PROMO_CODES_KEY || "",
  "/event/ticket/get-event-purchased-tickets":
    process.env.REACT_APP_ADMIN_API_PURCHASED_TICKETS_KEY || "",
  "/event/get-event-cancel-approve-details":
    process.env.REACT_APP_ADMIN_API_CANCELLED_APPROVED_EVENTS_KEY || "",
  "/event/ticket/get-approved-ticket-refunds":
    process.env.REACT_APP_ADMIN_API_APPROVED_REFUND_KEY || "",
  "/event/ticket/get-ticket-refund-requests":
    process.env.REACT_APP_ADMIN_API_REFUND_REQUEST_KEY || "",
  "/event/ticket/get-declined-refund-requests":
    process.env.REACT_APP_ADMIN_API_REFUND_REQUEST_KEY || "",
  "/users/get-requested-users":
    process.env.REACT_APP_ADMIN_API_REQUESTED_USERS_KEY || "",
  "/users/get-matched-users":
    process.env.REACT_APP_ADMIN_API_MATCHED_USERS_KEY || "",
  "/event/payout/request-payout":
    process.env.REACT_APP_ADMIN_API_EVENT_PAYOUT_KEY || "",
   "/users/get-host-users":
    process.env.REACT_APP_ADMIN_API_HOST_LIST_USERS_KEY || "", 
    "/users/get-subscribed-users":
    process.env.REACT_APP_ADMIN_API_HOST_LIST_USERS_KEY || "",
    "/export/export-events":
    process.env.REACT_APP_ADMIN_API_EVENTS_EXPORT_CSV_KEY || "YHU956-VYYUHU-YUY98-567G-67TUHB",
    "/export/export-user-event-stats":
    process.env.REACT_APP_ADMIN_API_USERS_EXPORT_CSV_KEY || "YHU956-VYYUHU-YUY98-567G-67TUHB",
    "/version/update-android-app-version":
    process.env.REACT_APP_ADMIN_API_MOBILE_VERSIONING_KEY || "YYUO56-V09JU-NU7Y98-567G-6HUUHB",
    "/version/get-android-app-version":
    process.env.REACT_APP_ADMIN_API_MOBILE_VERSIONING_KEY || "YYUO56-V09JU-NU7Y98-567G-6HUUHB",
    "/tax/get-state-tax-configs":
    process.env.REACT_APP_ADMIN_API_TAX_CONFIG_KEY || "YHYU56-VI9HU-YUY98-578TG-6787HT",
    "/tax/update-state-tax-config":
    process.env.REACT_APP_ADMIN_API_TAX_CONFIG_KEY || "YHYU56-VI9HU-YUY98-578TG-6787HT",
    "/users/events/get-user-event-activity":
    process.env.REACT_APP_ADMIN_API_USER_EVENT_ACTIVITY_KEY || "4039NBBB-B9F1-4E73-9AF9-D28E7C00AUE2",
    "/export/export-user-event-activity":
    process.env.REACT_APP_ADMIN_API_USER_EVENT_ACTIVITY_EXPORT_KEY || "YHU956-VYYUHU-YUY98-567G-67TUHB",
    "/export/export-matched-users":
    process.env.REACT_APP_ADMIN_API_MATCHED_USERS_EXPORT_KEY || "YHU956-VYYUHU-YUY98-567G-67TUHB",
    "/export/export-requested-users":
    process.env.REACT_APP_ADMIN_API_REQUESTED_USERS_EXPORT_KEY || "YHU956-VYYUHU-YUY98-567G-67TUHB",
    "/export/export-guest-list":
    process.env.REACT_APP_ADMIN_API_GUEST_LIST_EXPORT_KEY || "YHU956-VYYUHU-YUY98-567G-67TUHB",
};


export {
  FAQ_TYPES,
  SORT_BY,
  DATE_FILTER,
  MY_EVENTS_TYPES,
  HOST_CENTER_TYPES,
  EVENT_ATTENDING_ANSWER,
  GUEST_LIST_TABS,
  LOCAL_STORAGE,
  EVENT_SHARE_TYPE,
  EVENT_ATTENDING_STATUS,
  API_VERSION,
  DRAWERS,
  GENDER,
  CONNECTION_PREFERENCE,
  CONNECTION_STATUS,
  REVENUE_DATE_FILTER,
  REPORT_TYPES,
  ButtonVisibility,
  NOTIFICATION_REDIR_LIST,
  WEB_URL,
  WEB_SUPPORT_EMAIL,
  AUTH_NAVIGATE_OPTIONS,
  CONNECTION_REQUEST_STATUS,
  EVENT_LIST_LIMIT_PER_SCREEN,
  REVENUE_DATE_FILTER_OPTIONS,
  GENDERDECODE,
  FAQS,
};
